import 'core-js/modules/es6.reflect.construct.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _get from '@babel/runtime/helpers/esm/get';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import 'core-js/modules/es6.array.fill.js';
import cx from 'classnames';
import * as React from 'react';
import { refHandler, setRef } from './additionalExports.js';
import { Keys, Popover, InputGroup, Intent, AbstractPureComponent2, DISPLAYNAME_PREFIX } from '@blueprintjs/core';
import { DATEPICKER_NAVBUTTON, DATEPICKER_DAY, DATEINPUT_POPOVER } from './common/classes.js';
import { isDateValid, isDayInRange } from './common/dateUtils.js';
import { getFormattedDateString } from './dateFormat.js';
import { DatePicker } from './datePicker.js';
import { getDefaultMaxDate, getDefaultMinDate } from './datePickerCore.js';
import { isEmpty } from 'ramda';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DateInput = /*#__PURE__*/function (_AbstractPureComponen) {
  _inherits(DateInput, _AbstractPureComponen);

  var _super = _createSuper(DateInput);

  function DateInput() {
    var _this$props$inputProp;

    var _this;

    _classCallCheck(this, DateInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isInputFocused: false,
      isOpen: false,
      value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue,
      valueString: null
    };
    _this.inputElement = null;
    _this.popoverContentElement = null;
    _this.lastTabbableElement = null;
    _this.handleInputRef = refHandler(_assertThisInitialized(_this), "inputElement", (_this$props$inputProp = _this.props.inputProps) === null || _this$props$inputProp === void 0 ? void 0 : _this$props$inputProp.inputRef);
    _this.handlePopoverContentRef = refHandler(_assertThisInitialized(_this), "popoverContentElement");

    _this.handleClosePopover = function (e) {
      var _popoverProps$onClose;

      var _this$props$popoverPr = _this.props.popoverProps,
          popoverProps = _this$props$popoverPr === void 0 ? {} : _this$props$popoverPr;
      (_popoverProps$onClose = popoverProps.onClose) === null || _popoverProps$onClose === void 0 ? void 0 : _popoverProps$onClose.call(popoverProps, e);

      _this.setState({
        isOpen: false
      });
    };

    _this.handleDateChange = function (newDate, isUserChange) {
      var _this$props$onChange, _this$props;

      var didSubmitWithEnter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var prevDate = !isEmpty(_this.state.value) ? _this.state.value : null; // this change handler was triggered by a change in month, day, or (if
      // enabled) time. for UX purposes, we want to close the popover only if
      // the user explicitly clicked a day within the current month.

      var isOpen = !isUserChange || !_this.props.closeOnSelection || prevDate != null && (_this.hasMonthChanged(prevDate, newDate) || _this.hasTimeChanged(prevDate, newDate)); // if selecting a date via click or Tab, the input will already be
      // blurred by now, so sync isInputFocused to false. if selecting via
      // Enter, setting isInputFocused to false won't do anything by itself,
      // plus we want the field to retain focus anyway.
      // (note: spelling out the ternary explicitly reads more clearly.)


      var isInputFocused = didSubmitWithEnter ? true : false;

      if (_this.props.value === undefined) {
        var valueString = getFormattedDateString(newDate, _this.props);

        _this.setState({
          isInputFocused: isInputFocused,
          isOpen: isOpen,
          value: newDate,
          valueString: valueString
        });
      } else {
        _this.setState({
          isInputFocused: isInputFocused,
          isOpen: isOpen
        });
      }

      (_this$props$onChange = (_this$props = _this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, newDate, isUserChange);
    };

    _this.handleInputFocus = function (e) {
      var valueString = _this.state.value == null ? "" : _this.formatDate(_this.state.value);

      _this.setState({
        isInputFocused: true,
        isOpen: true,
        valueString: valueString
      });

      _this.safeInvokeInputProp("onFocus", e);
    };

    _this.handleInputClick = function (e) {
      // stop propagation to the Popover's internal handleTargetClick handler;
      // otherwise, the popover will flicker closed as soon as it opens.
      e.stopPropagation();

      _this.safeInvokeInputProp("onClick", e);
    };

    _this.handleInputChange = function (e) {
      var valueString = e.target.value;

      var value = _this.parseDate(valueString);

      if (isDateValid(value) && _this.isDateInRange(value)) {
        var _this$props$onChange2, _this$props2;

        if (_this.props.value === undefined) {
          _this.setState({
            value: value,
            valueString: valueString
          });
        } else {
          _this.setState({
            valueString: valueString
          });
        }

        (_this$props$onChange2 = (_this$props2 = _this.props).onChange) === null || _this$props$onChange2 === void 0 ? void 0 : _this$props$onChange2.call(_this$props2, value, true);
      } else {
        if (valueString.length === 0) {
          var _this$props$onChange3, _this$props3;

          (_this$props$onChange3 = (_this$props3 = _this.props).onChange) === null || _this$props$onChange3 === void 0 ? void 0 : _this$props$onChange3.call(_this$props3, null, true);
        }

        _this.setState({
          valueString: valueString
        });
      }

      _this.safeInvokeInputProp("onChange", e);
    };

    _this.handleInputBlur = function (e) {
      var valueString = _this.state.valueString;

      var date = _this.parseDate(valueString);

      if (valueString.length > 0 && valueString !== getFormattedDateString(_this.state.value, _this.props) && (!isDateValid(date) || !_this.isDateInRange(date))) {
        if (_this.props.value === undefined) {
          _this.setState({
            isInputFocused: false,
            value: date,
            valueString: null
          });
        } else {
          _this.setState({
            isInputFocused: false
          });
        }

        if (isNaN(date === null || date === void 0 ? void 0 : date.valueOf())) {
          var _this$props$onError, _this$props4;

          (_this$props$onError = (_this$props4 = _this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props4, new Date(undefined));
        } else if (!_this.isDateInRange(date)) {
          var _this$props$onError2, _this$props5;

          (_this$props$onError2 = (_this$props5 = _this.props).onError) === null || _this$props$onError2 === void 0 ? void 0 : _this$props$onError2.call(_this$props5, date);
        } else {
          var _this$props$onChange4, _this$props6;

          (_this$props$onChange4 = (_this$props6 = _this.props).onChange) === null || _this$props$onChange4 === void 0 ? void 0 : _this$props$onChange4.call(_this$props6, date, true);
        }
      } else {
        if (valueString.length === 0) {
          _this.setState({
            isInputFocused: false,
            value: null,
            valueString: null
          });
        } else {
          _this.setState({
            isInputFocused: false
          });
        }
      }

      _this.registerPopoverBlurHandler();

      _this.safeInvokeInputProp("onBlur", e);
    };

    _this.handleInputKeyDown = function (e) {
      // HACKHACK: https://github.com/palantir/blueprint/issues/4165

      /* eslint-disable deprecation/deprecation */
      if (e.which === Keys.ENTER) {
        var nextDate = _this.parseDate(_this.state.valueString);

        _this.handleDateChange(nextDate, true, true);
      } else if (e.which === Keys.TAB) {
        _this.setState({
          isOpen: false
        });
      } else if (e.which === Keys.ESCAPE) {
        var _this$inputElement;

        _this.setState({
          isOpen: false
        });

        (_this$inputElement = _this.inputElement) === null || _this$inputElement === void 0 ? void 0 : _this$inputElement.blur();
      }

      _this.safeInvokeInputProp("onKeyDown", e);
    };

    _this.getLastTabbableElement = function () {
      var _this$popoverContentE, _tabbableElements$len;

      // Popover contents are well structured, but the selector will need
      // to be updated if more focusable components are added in the future
      var tabbableElements = (_this$popoverContentE = _this.popoverContentElement) === null || _this$popoverContentE === void 0 ? void 0 : _this$popoverContentE.querySelectorAll("input, [tabindex]:not([tabindex='-1'])");
      var numOfElements = (_tabbableElements$len = tabbableElements === null || tabbableElements === void 0 ? void 0 : tabbableElements.length) !== null && _tabbableElements$len !== void 0 ? _tabbableElements$len : 0; // Keep track of the last focusable element in popover and add
      // a blur handler, so that when:
      // * user tabs to the next element, popover closes
      // * focus moves to element within popover, popover stays open

      var lastTabbableElement = numOfElements > 0 ? tabbableElements === null || tabbableElements === void 0 ? void 0 : tabbableElements[numOfElements - 1] : null;
      return lastTabbableElement;
    };

    _this.handlePopoverBlur = function (e) {
      var relatedTarget = e.relatedTarget;

      if (relatedTarget == null) {
        // Support IE11 (#2924)
        relatedTarget = document.activeElement;
      }

      var eventTarget = e.target; // Beware: this.popoverContentElement is sometimes null under Chrome

      if (relatedTarget == null || _this.popoverContentElement != null && !_this.popoverContentElement.contains(relatedTarget)) {
        // Exclude the following blur operations that makes "body" the activeElement
        // and would close the Popover unexpectedly
        // - On disabled change months buttons
        // - DayPicker day elements, their "blur" will be managed at its own onKeyDown
        var isChangeMonthEvt = eventTarget.classList.contains(DATEPICKER_NAVBUTTON);
        var isChangeMonthButtonDisabled = isChangeMonthEvt && eventTarget.disabled;
        var isDayPickerDayEvt = eventTarget.classList.contains(DATEPICKER_DAY);

        if (!isChangeMonthButtonDisabled && !isDayPickerDayEvt) {
          _this.handleClosePopover();
        }
      } else if (relatedTarget != null) {
        var _this$lastTabbableEle;

        _this.unregisterPopoverBlurHandler();

        _this.lastTabbableElement = _this.getLastTabbableElement();
        (_this$lastTabbableEle = _this.lastTabbableElement) === null || _this$lastTabbableEle === void 0 ? void 0 : _this$lastTabbableEle.addEventListener("blur", _this.handlePopoverBlur);
      }
    };

    _this.registerPopoverBlurHandler = function () {
      if (_this.popoverContentElement != null) {
        var _this$lastTabbableEle2;

        _this.unregisterPopoverBlurHandler();

        _this.lastTabbableElement = _this.getLastTabbableElement();
        (_this$lastTabbableEle2 = _this.lastTabbableElement) === null || _this$lastTabbableEle2 === void 0 ? void 0 : _this$lastTabbableEle2.addEventListener("blur", _this.handlePopoverBlur);
      }
    };

    _this.unregisterPopoverBlurHandler = function () {
      var _this$lastTabbableEle3;

      (_this$lastTabbableEle3 = _this.lastTabbableElement) === null || _this$lastTabbableEle3 === void 0 ? void 0 : _this$lastTabbableEle3.removeEventListener("blur", _this.handlePopoverBlur);
    };

    _this.handleShortcutChange = function (_, selectedShortcutIndex) {
      _this.setState({
        selectedShortcutIndex: selectedShortcutIndex
      });
    };

    return _this;
  }

  _createClass(DateInput, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unregisterPopoverBlurHandler();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          value = _this$state.value,
          valueString = _this$state.valueString;
      var dateString = this.state.isInputFocused ? valueString : getFormattedDateString(value, this.props);
      var dateValue = isDateValid(value) ? value : null;

      var dayPickerProps = _objectSpread(_objectSpread({}, this.props.dayPickerProps), {}, {
        // If the user presses the TAB key on a DayPicker Day element and the lastTabbableElement is also a DayPicker Day
        // element, the popover should be closed
        onDayKeyDown: function onDayKeyDown(day, modifiers, e) {
          var _this2$lastTabbableEl, _this2$props$dayPicke, _this2$props$dayPicke2;

          if (e.key === "Tab" && !e.shiftKey && (_this2$lastTabbableEl = _this2.lastTabbableElement) !== null && _this2$lastTabbableEl !== void 0 && _this2$lastTabbableEl.classList.contains(DATEPICKER_DAY)) {
            _this2.setState({
              isOpen: false
            });
          }

          (_this2$props$dayPicke = _this2.props.dayPickerProps) === null || _this2$props$dayPicke === void 0 ? void 0 : (_this2$props$dayPicke2 = _this2$props$dayPicke.onDayKeyDown) === null || _this2$props$dayPicke2 === void 0 ? void 0 : _this2$props$dayPicke2.call(_this2$props$dayPicke, day, modifiers, e);
        },
        // dom elements for the updated month is not available when
        // onMonthChange is called. setTimeout is necessary to wait
        // for the updated month to be rendered
        onMonthChange: function onMonthChange(month) {
          var _this2$props$dayPicke3, _this2$props$dayPicke4;

          (_this2$props$dayPicke3 = _this2.props.dayPickerProps) === null || _this2$props$dayPicke3 === void 0 ? void 0 : (_this2$props$dayPicke4 = _this2$props$dayPicke3.onMonthChange) === null || _this2$props$dayPicke4 === void 0 ? void 0 : _this2$props$dayPicke4.call(_this2$props$dayPicke3, month);

          _this2.setTimeout(_this2.registerPopoverBlurHandler);
        }
      });

      var maxDate = this.props.maxDate ? this.props.maxDate : getDefaultMaxDate();
      var minDate = this.props.minDate ? this.props.minDate : getDefaultMinDate();
      var initialMonth = dateValue !== null && dateValue !== void 0 ? dateValue : new Date();

      if (minDate > initialMonth) {
        initialMonth = minDate;
      } else if (maxDate < initialMonth) {
        initialMonth = maxDate;
      }

      var wrappedPopoverContent = /*#__PURE__*/React.createElement("div", {
        ref: this.handlePopoverContentRef
      }, /*#__PURE__*/React.createElement(DatePicker, _extends({}, this.props, {
        dayPickerProps: dayPickerProps,
        onChange: this.handleDateChange,
        initialMonth: initialMonth,
        value: dateValue,
        onShortcutChange: this.handleShortcutChange,
        selectedShortcutIndex: this.state.selectedShortcutIndex
      }))); // assign default empty object here to prevent mutation

      var _this$props7 = this.props,
          _this$props7$inputPro = _this$props7.inputProps,
          inputProps = _this$props7$inputPro === void 0 ? {} : _this$props7$inputPro,
          _this$props7$popoverP = _this$props7.popoverProps,
          popoverProps = _this$props7$popoverP === void 0 ? {} : _this$props7$popoverP;
      var isErrorState = value != null && (!isDateValid(value) || !this.isDateInRange(value));
      return (
        /*#__PURE__*/

        /* eslint-disable-next-line deprecation/deprecation */
        React.createElement(Popover, _extends({
          isOpen: this.state.isOpen && !this.props.disabled,
          fill: this.props.fill
        }, popoverProps, {
          autoFocus: false,
          className: cx(popoverProps.className, this.props.className),
          content: wrappedPopoverContent,
          enforceFocus: false,
          onClose: this.handleClosePopover,
          popoverClassName: cx(DATEINPUT_POPOVER, popoverProps.popoverClassName)
        }), /*#__PURE__*/React.createElement(InputGroup, _extends({
          className: "vds-date-input",
          autoComplete: "off",
          intent: isErrorState ? Intent.DANGER : Intent.NONE,
          placeholder: this.props.placeholder,
          rightElement: this.props.rightElement,
          type: "text"
        }, inputProps, {
          disabled: this.props.disabled,
          inputRef: this.handleInputRef,
          onBlur: this.handleInputBlur,
          onChange: this.handleInputChange,
          onClick: this.handleInputClick,
          onFocus: this.handleInputFocus,
          onKeyDown: this.handleInputKeyDown,
          value: dateString
        })))
      );
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _prevProps$inputProps, _this$props$inputProp2;

      _get(_getPrototypeOf(DateInput.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);

      if (((_prevProps$inputProps = prevProps.inputProps) === null || _prevProps$inputProps === void 0 ? void 0 : _prevProps$inputProps.inputRef) !== ((_this$props$inputProp2 = this.props.inputProps) === null || _this$props$inputProp2 === void 0 ? void 0 : _this$props$inputProp2.inputRef)) {
        var _prevProps$inputProps2, _this$props$inputProp3, _this$props$inputProp4;

        setRef((_prevProps$inputProps2 = prevProps.inputProps) === null || _prevProps$inputProps2 === void 0 ? void 0 : _prevProps$inputProps2.inputRef, null);
        this.handleInputRef = refHandler(this, "inputElement", (_this$props$inputProp3 = this.props.inputProps) === null || _this$props$inputProp3 === void 0 ? void 0 : _this$props$inputProp3.inputRef);
        setRef((_this$props$inputProp4 = this.props.inputProps) === null || _this$props$inputProp4 === void 0 ? void 0 : _this$props$inputProp4.inputRef, this.inputElement);
      }

      if (prevProps.value !== this.props.value) {
        this.setState({
          value: this.props.value
        });
      }
    }
  }, {
    key: "isDateInRange",
    value: function isDateInRange(value) {
      return isDayInRange(value, [this.props.minDate, this.props.maxDate]);
    }
  }, {
    key: "hasMonthChanged",
    value: function hasMonthChanged(prevDate, nextDate) {
      return prevDate == null !== (nextDate == null) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getMonth()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getMonth());
    }
  }, {
    key: "hasTimeChanged",
    value: function hasTimeChanged(prevDate, nextDate) {
      if (this.props.timePrecision == null) {
        return false;
      }

      return prevDate == null !== (nextDate == null) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getHours()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getHours()) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getMinutes()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getMinutes()) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getSeconds()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getSeconds()) || (nextDate === null || nextDate === void 0 ? void 0 : nextDate.getMilliseconds()) !== (prevDate === null || prevDate === void 0 ? void 0 : prevDate.getMilliseconds());
    }
  }, {
    key: "safeInvokeInputProp",
    value:
    /** safe wrapper around invoking input props event handler (prop defaults to undefined) */
    function safeInvokeInputProp(name, e) {
      var _inputProps$name;

      var _this$props$inputProp5 = this.props.inputProps,
          inputProps = _this$props$inputProp5 === void 0 ? {} : _this$props$inputProp5;
      (_inputProps$name = inputProps[name]) === null || _inputProps$name === void 0 ? void 0 : _inputProps$name.call(inputProps, e);
    }
  }, {
    key: "parseDate",
    value: function parseDate(dateString) {
      if (dateString === this.props.outOfRangeMessage || dateString === this.props.invalidDateMessage) {
        return null;
      }

      var _this$props8 = this.props,
          locale = _this$props8.locale,
          parseDate = _this$props8.parseDate;
      var newDate = parseDate(dateString, locale);
      return newDate === false ? new Date(undefined) : newDate;
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      if (!isDateValid(date) || !this.isDateInRange(date)) {
        return "";
      }

      var _this$props9 = this.props,
          locale = _this$props9.locale,
          formatDate = _this$props9.formatDate;
      return formatDate(date, locale);
    }
  }]);

  return DateInput;
}(AbstractPureComponent2);
DateInput.displayName = "".concat(DISPLAYNAME_PREFIX, ".DateInput");
DateInput.defaultProps = {
  closeOnSelection: true,
  dayPickerProps: {},
  disabled: false,
  invalidDateMessage: "Invalid date",
  maxDate: getDefaultMaxDate(),
  minDate: getDefaultMinDate(),
  outOfRangeMessage: "Out of range",
  reverseMonthAndYearMenus: false
};

export { DateInput };
//# sourceMappingURL=dateInput.js.map
